import PartnerAppRepository from "lib/repositories/PartnerAppRepository";
import logError from "lib/utils/errors/logError";
import dejsonapinize from "lib/utils/api/dejsonapinize";

class AppSettings {
  fetch() {
    this._fetchLoading = true;
    return PartnerAppRepository.getConstants().do(
      (data) => {
        this._fetchLoading = false;
        this._fetchDone = true;
        Object.assign(this, {
          ...data,
          product_category_tags:
            data.product_category_tags &&
            dejsonapinize(data.product_category_tags.data, data.product_category_tags.included),
          product_location_tags:
            data.product_location_tags &&
            dejsonapinize(data.product_location_tags.data, data.product_location_tags.included),
        });
        return this;
      },
      (e) => {
        this._fetchLoading = false;
        this._fetchFailed = true;
      }
    );
  }

  getLanguageName(locale) {
    const arr = (this.all_locales_with_labels || []).find(([key, name]) => key === locale);
    return arr ? arr[1] : locale;
  }
}

const appSettings = new AppSettings();

export default appSettings;



// WEBPACK FOOTER //
// ./src/lib/services/AppSettings.js